// src/Pages/Catalog/CmsCatalog.tsx
import React, { useMemo } from "react";
import { useParams } from "react-router-dom";
import { CommonService } from "Components/CommonService";
import CategoryPageRenderer from "./cmscatalog/CategoryPageRenderer";

const CmsCatalog = () => {
  const { categorySlug } = useParams();

  const title = useMemo(() => {
    if (categorySlug) return `${categorySlug} | Toner - React FrontEnd`;
    return "Catalog | Toner - React FrontEnd";
  }, [categorySlug]);

  document.title = title;

  if (!categorySlug) return null;

  return (
    <React.Fragment>
      <CategoryPageRenderer categorySlug={categorySlug} />
      <CommonService />
    </React.Fragment>
  );
};

export default CmsCatalog;